import wineData from "../data/wineData";
export function getYearFilterOptions() {
    
    const allUniqueYears = [];
    wineData.forEach(wine => {
        if (wine.year && !allUniqueYears.includes(wine.year)) {
            allUniqueYears.push(wine.year);
        }
    });

    const yearsFilter = [
        { value: 'all', label: { en: 'All', pt: 'Todos' } },
    ]
    allUniqueYears.forEach(year => {
        yearsFilter.push({ value: year, label: year });
    });
    const sorted = yearsFilter.sort((a, b) => b.value - a.value);
    return sorted;
}